import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import AppStore from '../../stores/AppStore'
import TemplateData, { localsMessages } from '../../utility/getTemplateData'
import { hideSpinnerOverlay, setFocus } from '../../utility/helper';
import * as FPT from '../../utility/fpt'
import _isFunction from 'lodash/isFunction';
import _get from 'lodash/get';
import { hideLanguageSelector } from '../../utility/languageSelector';
import { Text } from '@paypalcorp/pp-react';
import SignUpAlert from '../../components/guest/SignUpAlert';
import Illustration from '../../components/illustrations/Illustration';
import ConfirmationTitle from '../../confirmation/ConfirmationTitle';
import ConfirmationBody from '../../confirmation/ConfirmationBody';
import OfferConfirmation from '../../components/offerConfirmation';
import VoucherFlowDisclaimer from '../../components/voucherFlowDisclaimer';

const messages = localsMessages('confirmation/pending')

export default class extends React.Component {
    static propTypes = {
		label: PropTypes.string
	};

    constructor(props) {
        super(props);

        let confirmationData = AppStore.getConfirmation() || {}

        this.state = {
			amount: confirmationData.amount || '',
			postBackData: confirmationData.postBackData || {},
			syncReturnUrl: confirmationData.syncReturnUrl || '',
			isSignUp: confirmationData.isSignUp || false,
			signUpStatus: confirmationData.signUpSuccess || false,
			orgName: TemplateData.donationName ? TemplateData.donationName : '',
			txnId: confirmationData.postBackData && confirmationData.postBackData.txn_id || '',

			autoRedirect: TemplateData.returnAutoRedirect !== '',
			autoRedirectUrl: (TemplateData.charityReturnUrl) ? TemplateData.charityReturnUrl : '',
			autoRedirectMethod: (TemplateData.returnMethod) ? TemplateData.returnMethod : '',

			isVoucherFlow: TemplateData.isVoucherFlow,
			offerProgram: TemplateData.offerProgram,
		};
    }

    componentDidMount() {
		this.isComponentMounted = true;
		hideLanguageSelector();

		this.serverRequest = $.post('/donate/guest/postTransaction', {}).then((response) => {
			hideSpinnerOverlay();
			setFocus();
			if (response.data.confirmationData) {
				if (this.isComponentMounted) {
					this.updatePendingData(response);
				}
			}
		})

		let confData = AppStore.getConfirmation() || {}
		let trid = confData.confirmationNumber || '';

		if (TemplateData.fptPageName === 'guestULSignUp') {
			FPT.trackPage('main:donate:wps:signup:pending', 'main:donate:wps:signup:pending:web::', 'trid', trid)
		} else {
			FPT.trackPage('main:donate:wps:guest:pending', 'main:donate:wps:guest:pending:web::', 'trid', trid)
		}
	}

	updatePendingData = (response) => {
		this.setState({
			amount: response.data.confirmationData.amount || AppStore.getDonationAmount(),
			isSignUp: response.data.confirmationData.isSignUp || false,
			signUpStatus: response.data.confirmationData.signUpSuccess || false,
			txnId: _get(response.data.confirmationData, 'postBackData.txn_id', '')
		})
	};

    componentWillUnmount() {
		this.isComponentMounted = false;
		if (this.serverRequest && _isFunction(this.serverRequest.abort)) {
			this.serverRequest.abort()
		}
	}

	handleAutoRedirect = () => {
		let finalUrl = this.state.autoRedirectUrl
		if (finalUrl.indexOf('http') != 0 && finalUrl.indexOf('//') != 0) {
		    finalUrl = '//' + finalUrl;
		}

		window.location.href = finalUrl
	}

    handleMyAccount = () => {
		FPT.trackLinkClick('myAccount');
		window.location.href = '/myaccount'
	};

    render() {

		let returnTextMember = messages.label && messages.label.returnTextMember || ''
		let returnto = messages.label && messages.label.returnto || ''
		let pending = messages.label && messages.label.pending || ''
		let pending2 = messages.label && messages.label.pending2 || ''
		let txnId = messages.label && messages.label.txnId || ''

		returnTextMember = returnTextMember.replace('{orgName}', this.state.orgName)

		returnto = returnto.replace('{orgName}', this.state.orgName)

		txnId = txnId && txnId.replace('{txnId}', this.state.txnId)
		const { successMessage, failMessage } = messages.label
		const guestSignUpProps = {
			successMessage,
			failMessage,
			signUpStatus: this.state.signUpStatus
		}

		return (
			<div>
				{this.state.isSignUp && <SignUpAlert { ...guestSignUpProps } />}
				<div className="donate_wrapper confirmation">
					<div className="ppvx_row">
						<div className="ppvx_col-12">
							<div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
	        					<Illustration type="warning" />
	        				</div>
						</div>
					</div>
					<div className="ppvx_row">
						<div className="ppvx_col-12 text-center">
							<ConfirmationTitle message={pending} />
						</div>
					</div>
					<div className="ppvx_row">
						<div className="ppvx_col-12 text-center">
							<ConfirmationBody message={pending2} />
						</div>
					</div>
					<div className="ppvx_row">
						<div className="ppvx_col-12 text-center">
							<Text
								size="sm"
								style={{
									color: '#687173',
								}}
							>
								{txnId}
							</Text>
						</div>
					</div>
					{this.state.isVoucherFlow &&
						<OfferConfirmation
							offerProgram={this.state.offerProgram}
							txnId={txnId}/>
					}
					{this.state.autoRedirect && this.state.autoRedirectUrl &&
						<div className="ppvx_row">
							<div className="ppvx_col-12">
								{
									this.state.orgName ?
									<div className="text-center">
										<a id="returnUrl" href="#" onClick={this.handleAutoRedirect}>{returnTextMember}</a>
									</div> :
									<div className="text-center">
										<a id="returnUrl" href="#" onClick={this.handleAutoRedirect}>{returnto}</a>
									</div>
								}
							</div>
						</div>
					}
					{this.state.isVoucherFlow && <VoucherFlowDisclaimer />}
				</div>
			</div>
		);
	}
}
